import type { LanguageInfo } from '../types';

/**
 * Language patterns for markup and data languages
 */
export const markupLanguagePatterns: LanguageInfo[] = [
  {
    name: 'json',
    patterns: [
      /^\s*\{[\s\S]*\}\s*$/,
      /^\s*\[[\s\S]*\]\s*$/,
      /"\w+":\s*(?:"|{|\[|\d+|true|false|null)/,
      /,\s*"[\w-]+"\s*:/,
      /"[\w-]+"\s*:\s*\{/,
      /"[\w-]+"\s*:\s*\[/,
      /"[\w-]+"\s*:\s*"[^"]*"/,
      /"[\w-]+"\s*:\s*\d+/,
      /"[\w-]+"\s*:\s*(?:true|false|null)\b/
    ],
    confidencePatterns: [
      /^[\s\n]*\{[\s\S]*\}\s*$/,
      /^[\s\n]*\[[\s\S]*\]\s*$/,
      /"[\w-]+"\s*:/,
      /^[\s\n]*\{\s*"[\w-]+"\s*:/,
      /^[\s\n]*\[\s*\{/
    ],
    negativePatterns: [
      /^\s*</,
      /^\s*function/,
      /^\s*import/,
      /^\s*export/,
      /'/,
      /\/\//,
      /undefined/,
      /\bvar\b/,
      /\blet\b/,
      /\bconst\b/,
      /\bfunction\b/,
      /=>/,
      /\${/,
      /^\s*\{[\s\S]*(?:function|=>|const|let|var|return)[\s\S]*\}\s*$/,
      /^\s*\{[\s\S]*(?:\/\/|\/\*)[\s\S]*\}\s*$/
    ],
    requiresMatch: 2,
    extensions: ['.json'],
    keywords: ['true', 'false', 'null']
  },
  {
    name: 'markdown',
    patterns: [/^#{1,6}\s+/m, /\[.+\]\(.+\)/, /^[-*+]\s+/m],
    extensions: ['.md', '.markdown'],
    keywords: ['#', '##', '###', '```', '---', '> ']
  },
  {
    name: 'yaml',
    patterns: [/^[\w-]+:\s*/m, /^\s*-\s+/m],
    extensions: ['.yml', '.yaml'],
    keywords: ['true', 'false', 'null', '---']
  },
  {
    name: 'xml',
    patterns: [
      /<[\w-]+>[\s\S]*?<\/[\w-]+>/,
      /<[\w-]+(\s+[\w-]+="[^"]*")*\s*>/,
      /<\/[\w-]+>/,
      // More specific XML patterns with higher weights
      /<[a-z][\w-]*>[^<>]*<\/[a-z][\w-]*>/i, // Simple element with content
      /<[a-z][\w-]*\s+[a-z][\w-]*="[^"]*"\s*\/>/i, // Self-closing with attributes
      /<\w+>\s*\w+\s*<\/\w+>/ // Simple element with text content
    ],
    confidencePatterns: [
      /<\?xml/, // XML declaration (highest confidence)
      /<!DOCTYPE\s+[^>]+>(?!html)/i, // DOCTYPE declaration (not HTML)
      /<[a-z][\w-]*:[a-z][\w-]*>/i, // Namespaced elements
      /<request>|<response>/i, // Common XML root elements
      /<\w+\s+xmlns=/i, // XML namespace declarations
      /<\/?\w+Request>|<\/?\w+Response>/i, // Common SOAP/REST patterns
      /<\w+\s+encoding=/i // XML encoding declarations
    ],
    negativePatterns: [
      /<!DOCTYPE\s+html>/i, // HTML DOCTYPE
      /<(html|head|body|script|div|span|p|a|img)\b/i, // Common HTML tags
      /<link\s+rel=/i, // HTML link tag
      /class="[\w\s-]*"/, // HTML class attribute
      /<style\b/i, // HTML style tag
      /<meta\b/i, // HTML meta tag
      /\.html?\b/i // HTML file extensions in text
    ],
    requiresMatch: 1,
    extensions: ['.xml', '.xsd', '.wsdl', '.soap', '.plist', '.svg'],
    keywords: ['version', 'encoding', 'DOCTYPE', 'CDATA', 'xmlns', 'schema', 'element', 'attribute']
  }
];
